function JSServer(name, callFunction) {
    callFunction = callFunction || function () {
    };
    this._callFunction = callFunction;
    window[name || 'jsServer'] = this;
}

JSServer.prototype = {
    sendCommand: function (method, data, fn) {
        Logger.log('JSServer.sendCommand', method, data);
        this._callFunction(method, data, fn);
    }
};
